import { Result } from 'antd';
import { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';

import { useUser, useVerifyCallback } from '../hooks';

const AuthCallbackPage = () => {
  const [searchParams] = useSearchParams();
  const { data: user } = useUser();
  const { mutate: verifyCallback } = useVerifyCallback();

  const navigate = useNavigate();

  useEffect(() => {
    const handleAuth = async () => {
      verifyCallback({
        code: searchParams.get('code') as string,
        state: searchParams.get('state') as string,
        iss: searchParams.get('iss') as string,
      });
      navigate('/');
    };
    handleAuth();
  }, [navigate, searchParams, verifyCallback]);

  return (
    <div className="flex justify-center items-center h-dynamic-70">
      <Result status={user ? 'success' : 'error'} title={user ? 'Sucessfully logged in!' : 'Something went wrong!'} />
    </div>
  );
};

export default AuthCallbackPage;
